import * as React from 'react';
import { FC, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu } from 'primereact/menu';
import { useSelector } from 'react-redux';
import { useAppDispatch, userSelector } from '../../state';
import { useAuth } from 'react-oidc-context';
import { CurrentApplicationsIcon, StartNewApplicationIcon } from '../atoms';
import { findGenericRequestsByStatus, GenericRequest, genericRequestSelector, GenericRequestStatus, getCompanyName, isSigningAllowed, issueCredential, signGenericRequest } from '../../state/slices/genericrequest';
import { OCard } from '../molecules';
import { Button } from 'primereact/button';

export const HomeCustomer: FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const {t} = useTranslation();
    const menuRef = useRef<Menu>(null);
    let user = useSelector(userSelector).singleItem;
    const auth = useAuth();

    function handleSign(genericRequest: GenericRequest) {
        navigate('/requestAccount/receiveCredentials/' + genericRequest.frontendCorrelationKey);
    }

    function getDate() {
        return new Date().toLocaleDateString('nl-NL', {});
    }

    return (
        <div className="container mx-auto px-4 mb-8">
            <h1 className="text-3xl mt-16 mb-8">Welcome {auth.user?.profile.name}</h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <OCard title="Pensioenuitkering">
                    <p>Verwachte persioenuitkering per jaar: <br/><span className="font-bold text-2xl">€ 35.563,- bruto</span></p>
                </OCard>
                <OCard title="Beleggingen">
                    <>
                        <div>De waarde van uw beleggingen op {getDate()}:</div>
                        <span className="font-bold text-2xl mb-8">€ 180.196,21</span>
                        <div className="text-xs">Uw deelname is niet meer actief. Er wordt geen nieuwe premie meer gestort.</div>
                    </>
                </OCard>
                <OCard title="Waardeoverdracht">
                    <p className="mb-8">Wilt u uw beleggingskapitaal onderbrengen bij uw nieuwe pensioenuitvoerder, kies dan voor een waardeoverdracht.</p>

                    <button className="place-self-end text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded transition duration-300 w-max" onClick={event => {navigate("/mijn/waardeoverdracht")}}>Waardeoverdracht</button>

                </OCard>
            </div>

        </div>
    );
}
